import { Injectable } from '@angular/core';
import {
  ComponentDescription,
  DataRepeaterComponent,
  WidgetComponent,
  WidgetComponentSubType,
  WidgetComponentType,
} from '../widgets.model';

@Injectable()
export class DataRepeaterService {
  constructor() {}

  public isSupportedComponentDescriptionForDataRepeater(
    component: WidgetComponent,
    componentDescription: ComponentDescription,
  ): boolean {
    if (!componentDescription.available) {
      return false;
    }
    const isGroupsAllowed = !DataRepeaterService.isComponentInsideDataRepeater(component);
    switch (componentDescription.subType) {
      case WidgetComponentSubType.ImageRegular:
        return true;
      case WidgetComponentSubType.TextRegular:
        return true;
      case WidgetComponentSubType.ButtonRegular:
        return true;
      case WidgetComponentSubType.GroupThreeColumns:
        return isGroupsAllowed;
      case WidgetComponentSubType.GroupTwoColumns:
        return isGroupsAllowed;
      case WidgetComponentSubType.GroupFourColumns:
        return isGroupsAllowed;
      case WidgetComponentSubType.GroupFiveColumns:
        return isGroupsAllowed;
      case WidgetComponentSubType.GroupTwoButtons:
        return isGroupsAllowed;
    }
    return false;
  }

  public static isComponentInsideDataRepeater(component: WidgetComponent): boolean {
    if (component.parentComponentType === WidgetComponentType.DataRepeater) {
      return true;
    }
    if (
      component.grandparentSubType === WidgetComponentSubType.DataRepeaterRegular ||
      component.grandparentSubType === WidgetComponentSubType.DataRepeaterLeaderboard
    ) {
      return true;
    }
    return false;
  }

  public hasDataSourceId(component: WidgetComponent) {
    const typedComponent = DataRepeaterService.toTyped(component);
    if (typedComponent && typedComponent.dataRepeaterSettings?.dataSourceId) {
      return true;
    }
    return false;
  }

  public static isDataRepeaterComponent(componentType: WidgetComponentType): boolean {
    if (componentType === WidgetComponentType.DataRepeater) {
      return true;
    }
    return false;
  }

  public static toTyped(component: WidgetComponent): DataRepeaterComponent {
    return component as DataRepeaterComponent;
  }
}
